import React, {Fragment} from 'react';

const Clear = props => {
  const {clearSelection} = props;

  return (
    <Fragment>
      <button className='btn btn__correction' onClick={clearSelection}>&nbsp;</button>
      <div className='label__correction'>Corr.</div>
    </Fragment>
  );
};

export default Clear;
